import { render, staticRenderFns } from "./YButton.vue?vue&type=template&id=046efe37&scoped=true"
import script from "./YButton.vue?vue&type=script&lang=js"
export * from "./YButton.vue?vue&type=script&lang=js"
import style0 from "./YButton.vue?vue&type=style&index=0&id=046efe37&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046efe37",
  null
  
)

export default component.exports